/** @jsx isolateComponent */
import { Fragment } from 'react';
import { isolateComponent } from '@zapier/style-encapsulation';
import { Icon, Link, Button, AnchorTarget } from '@zapier/design-system';
import { ComputedState, Styles } from './ZapCard';

type Props = {
  ariaHidden: boolean;
  href: string;
  target: AnchorTarget;
  computedState: ComputedState;
  isLink: boolean;
};

export const ZapCardCTA = (props: Props) => {
  const { computedState, ariaHidden, href, isLink, target } = props;

  const ctaBody = isLink ? (
    <Fragment>
      <Link
        css={Styles.ctaText(computedState)}
        href={href}
        target={target}
        tabIndex={ariaHidden ? -1 : undefined}
      >
        Try it
      </Link>
      <span css={Styles.ctaIcon(computedState)}>
        <Icon isBlock={true} name="arrowBigRight" size={24} />
      </span>
    </Fragment>
  ) : (
    <Button
      href={props.href}
      target={target}
      tabIndex={ariaHidden ? -1 : undefined}
      size="small"
    >
      Try it
    </Button>
  );

  return (
    // Add `aria-hidden` to avoid redundant CTAs if it's already handled by `link`.
    // Also add `tabIndex={-1}` to the `Link` or `Button` since nodes with `aria-hidden` on them
    // shouldn't contain interactive elements.
    <div aria-hidden={ariaHidden} css={Styles.ctaArea(computedState)}>
      {ctaBody}
    </div>
  );
};
